import { render, staticRenderFns } from "./MiniDataPanel.vue?vue&type=template&id=529c4538&scoped=true&"
import script from "./MiniDataPanel.vue?vue&type=script&lang=ts&"
export * from "./MiniDataPanel.vue?vue&type=script&lang=ts&"
import style0 from "./MiniDataPanel.vue?vue&type=style&index=0&id=529c4538&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529c4538",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VIcon,VRow,VTextField})
